module.exports = __webpack_public_path__ + "img/hfdl-icon-1@2x.dc3bf047.png";